import { DataFileInterface } from '@systemeio/file-manager'
import { LocaleEnum } from '@systemeio/types'
import { DataWithPaginationInterface } from 'shared/types/pagination-interface'

export enum CourseDuplicationStatusEnum {
  Ready = 'ready',
  Pending = 'pending',
}

export enum CourseEditorTypeEnum {
  LightCourse = 'light_course',
  ClassicCourse = 'classic_course',
}

export interface CourseInterface {
  active: boolean
  hash: string
  id: number
  loginLinkUrl: string
  name: string
  courseType: CourseEditorTypeEnum
  duplicationStatus?: CourseDuplicationStatusEnum
}

export type CourseId = CourseInterface['id']

export interface CourseEditApiInterface {
  id: number
  description: string | null
  domainId: number
  embeddedCode: null | string
  fontFamily: string
  headlineFontFamily: string
  image: null | DataFileInterface
  instructorName: null | string
  locale: LocaleEnum
  logo: null | DataFileInterface
  teacherPhoto: null | DataFileInterface
  name: string
  path: string
  salesFunnelId: null | number
  salesFunnelStepId: null | number
  showModulesTitles: boolean
  themeId: number
  issueCertificateUponCompletion?: boolean
  isDeactivated: boolean
  certificateLogo?: DataFileInterface | null
  signature?: DataFileInterface | null
  hasReminderSettings: boolean
  hasReminderEmailSettings: boolean
  courseType: CourseEditorTypeEnum
}

export interface CourseCreateInterface {
  description: string
  fontFamily: string
  headlineFontFamily: string
  name: string
  path: string
  showModulesTitles: boolean
  instructorName?: string
  domain?: number
  embeddedCode?: string
  salesFunnelStep?: number
  theme: number
  locale?: LocaleEnum
  logo?: number
  image?: number
  teacherPhoto?: number
}

export interface CourseEditInterface extends Omit<
  CourseCreateInterface,
  'domain' | 'embeddedCode' | 'instructorName' | 'salesFunnelStep' | 'locale'
> {
  domain: number
  embeddedCode: string
  instructorName: null | string
  salesFunnelStep: null | number
  locale: LocaleEnum
  issueCertificateUponCompletion?: boolean
  certificateLogo?: number
  signature?: number
}

export interface CourseErrorsInterface {
  fields: {
    name: string
    locale: string
    domain: string
    path: string
    fontFamily?: string
    headlineFontFamily?: string
    theme?: string
    teacherPhoto?: string
  }
  common: string[]
}
export interface CourseResponseErrorsInterface {
  common: string[]
  fields: {
    name: string[]
    locale: string[]
    domain: string[]
    path: string[]
    fontFamily: string[]
    headlineFontFamily: string[]
    theme: string[]
    teacherPhoto: string[]
  }
}

export interface CourseApiInterface extends DataWithPaginationInterface<CourseInterface> {}
